import { atom } from "jotai";
import { CustomFieldAtom } from "./type";

const initialValue: CustomFieldAtom = {
  selectedKeys: {
    INVOICES: [],
    PAYMENTS: [],
    CREDIT_NOTES: [],
    DISPUTES: [],
    PTPs: [],
    DOCUMENTS: [],
    PROFILE: [],
  },
  filterValues: {
    INVOICES: [],
    PAYMENTS: [],
    CREDIT_NOTES: [],
    DISPUTES: [],
    PTPs: [],
    DOCUMENTS: [],
    PROFILE: [],
  },
};
export const customFieldAtom = atom(initialValue);
